// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__nsr-9","error":"Textarea_error__2gi-t","readonly":"Textarea_readonly__VXjfY","disabled":"Textarea_disabled__3p4pj"};